import request from '@/router/axios'
import env from '@/config/env'

export const list = (data) => {
  return request({
    url: env.ferryUrl + '/driver/driver-registry/page',
    method: 'post',
    data
  })
}
